<neo-form-field [attr.data-aut-id]="autId() + '-field'">
  <!-- Selected items using custom template or default -->
  @if (selectedOptions().length > 0) {
    <div class="selected-items-container">
      @for (optionVm of selectedOptionVms(); track optionVm.key) {
        <div class="selected-item" [attr.data-aut-id]="autId() + '-selected-item-' + optionVm.key">
          @if (selectedItemTemplate()) {
            <div class="selected-item-content">
              <ng-container
                *ngTemplateOutlet="selectedItemTemplate()!; context: { $implicit: optionVm.option, remove: optionVm.remove }"
              />
            </div>
          } @else {
            <div class="selected-item-content">
              <span class="selected-item-text">{{ optionVm.label }}</span>
            </div>
          }
          <button
            type="button"
            class="selected-item-remove"
            (click)="onRemoveOption(optionVm.option)"
            [disabled]="disabled()"
            [attr.aria-label]="'Remove ' + optionVm.label"
            [attr.aut-id]="autId() + '-remove-' + optionVm.key"
          >
            <cm-icon name="close" size="xs" aria-hidden="true" />
          </button>
        </div>
      }
    </div>
  }
  <neo-label>{{ label() }}</neo-label>
  <input
    #inputRef
    neoInput
    [neoAutocomplete]="autoComplete"
    [placeholder]="placeholder()"
    [required]="required()"
    [disabled]="disabled()"
    [value]="searchValue()"
    (input)="onSearchChange($event)"
    (blur)="onInputBlur()"
    [attr.data-aut-id]="autId() + '-input'"
    [attr.aut-id]="autId() + '-input'"
  />
 <!-- <div #chipGrid></div> -->
  <neo-autocomplete-v2 #autoComplete="neoAutocomplete" (optionSelected)="onOptionSelected($event)" [multiple]="false">
    @if (loading()) {
      <neo-option [value]="null" [disabled]="true">
        <span class="loading-text">Loading...</span>
      </neo-option>
    } @else if (filteredOptions().length === 0 && searchValue()) {
      <neo-option [value]="null" [disabled]="true">
        <span class="no-results-text">No results found</span>
      </neo-option>
    } @else if (filteredOptions().length === 0 && !searchValue() && selectedOptions().length > 0) {
      <neo-option [value]="null" [disabled]="true">
        <span class="no-results-text">All options selected</span>
      </neo-option>
    } @else if(searchValue()){
      @for (optionVm of filteredOptionVms(); track optionVm.key) {
        <neo-option [value]="optionVm.option" (click)="$event.stopPropagation()">
          @if (optionItemTemplate()) {
            <ng-container *ngTemplateOutlet="optionItemTemplate()!; context: { $implicit: optionVm.option }" />
          } @else {
            <span class="option-text">{{ optionVm.label }}</span>
          }
        </neo-option>
      }
    }
  </neo-autocomplete-v2>

  @if (hint()) {
    <neo-hint>{{ hint() }}</neo-hint>
  }

  <cm-field-errors
    [control]="ngControl()?.control ?? null"
    [label]="label()"
    [customMessages]="errorMessages()"
    [showErrorsWhen]="showErrorsWhen()"
    [hideErrors]="hideErrors()"
  />
</neo-form-field>